var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments)).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t;
    return { next: verb(0), "throw": verb(1), "return": verb(2) };
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
(function () {
    var arrayPrototype = Array.prototype;
    if (!arrayPrototype.forEachAsync) {
        arrayPrototype.forEachAsync = function forEachAsync(callback, thisArg) {
            return __awaiter(this, void 0, void 0, function () {
                var T, k, O, len, kValue;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this === null) {
                                throw new TypeError(' this is null or not defined');
                            }
                            O = Object(this);
                            len = O.length >>> 0;
                            // 4. If isCallable(callback) is false, throw a TypeError exception.
                            // See: http://es5.github.com/#x9.11
                            if (typeof callback !== "function") {
                                throw new TypeError(callback + ' is not a function');
                            }
                            // 5. If thisArg was supplied, let T be thisArg; else let
                            // T be undefined.
                            if (thisArg !== undefined) {
                                T = thisArg;
                            }
                            // 6. Let k be 0
                            k = 0;
                            _a.label = 1;
                        case 1:
                            if (!(k < len))
                                return [3 /*break*/, 4];
                            kValue = void 0;
                            if (!(k in O))
                                return [3 /*break*/, 3];
                            // i. Let kValue be the result of calling the Get internal
                            // method of O with argument Pk.
                            kValue = O[k];
                            // ii. Call the Call internal method of callback with T as
                            // the this value and argument list containing kValue, k, and O.
                            return [4 /*yield*/, callback.call(T, kValue, k, O)];
                        case 2:
                            // ii. Call the Call internal method of callback with T as
                            // the this value and argument list containing kValue, k, and O.
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            // d. Increase k by 1.
                            k++;
                            return [3 /*break*/, 1];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
    }
    if (!arrayPrototype.everyAsync) {
        arrayPrototype.everyAsync = function everyAsync(predicate, thisArg) {
            'use strict';
            return __awaiter(this, void 0, void 0, function () {
                var T, k, O, len, kValue, testResult;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this == null) {
                                throw new TypeError('this is null or not defined');
                            }
                            O = Object(this);
                            len = O.length >>> 0;
                            // 4. If IsCallable(callbackfn) is false, throw a TypeError exception.
                            if (typeof predicate !== 'function') {
                                throw new TypeError();
                            }
                            // 5. If thisArg was supplied, let T be thisArg; else let T be undefined.
                            if (thisArg !== undefined) {
                                T = thisArg;
                            }
                            // 6. Let k be 0.
                            k = 0;
                            _a.label = 1;
                        case 1:
                            if (!(k < len))
                                return [3 /*break*/, 4];
                            kValue = void 0;
                            if (!(k in O))
                                return [3 /*break*/, 3];
                            // i. Let kValue be the result of calling the Get internal method
                            //    of O with argument Pk.
                            kValue = O[k];
                            return [4 /*yield*/, predicate.call(T, kValue, k, O)];
                        case 2:
                            testResult = _a.sent();
                            // iii. If ToBoolean(testResult) is false, return false.
                            if (!testResult) {
                                return [2 /*return*/, false];
                            }
                            _a.label = 3;
                        case 3:
                            k++;
                            return [3 /*break*/, 1];
                        case 4: return [2 /*return*/, true];
                    }
                });
            });
        };
    }
    if (!arrayPrototype.someAsync) {
        arrayPrototype.someAsync = function someAsync(predicate, thisArg) {
            'use strict';
            return __awaiter(this, void 0, void 0, function () {
                var t, len, i, _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (this == null) {
                                throw new TypeError('Array.prototype.some called on null or undefined');
                            }
                            if (typeof predicate !== 'function') {
                                throw new TypeError();
                            }
                            t = Object(this);
                            len = t.length >>> 0;
                            i = 0;
                            _b.label = 1;
                        case 1:
                            if (!(i < len))
                                return [3 /*break*/, 5];
                            _a = i in t;
                            if (!_a)
                                return [3 /*break*/, 3];
                            return [4 /*yield*/, predicate.call(thisArg, t[i], i, t)];
                        case 2:
                            _a = (_b.sent());
                            _b.label = 3;
                        case 3:
                            if (_a) {
                                return [2 /*return*/, true];
                            }
                            _b.label = 4;
                        case 4:
                            i++;
                            return [3 /*break*/, 1];
                        case 5: return [2 /*return*/, false];
                    }
                });
            });
        };
    }
    if (!arrayPrototype.filterAsync) {
        arrayPrototype.filterAsync = function filterAsync(predicate, thisArg) {
            'use strict';
            return __awaiter(this, void 0, void 0, function () {
                var t, len, res, i, val;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this === void 0 || this === null) {
                                throw new TypeError();
                            }
                            t = Object(this);
                            len = t.length >>> 0;
                            if (typeof predicate !== 'function') {
                                throw new TypeError();
                            }
                            res = [];
                            i = 0;
                            _a.label = 1;
                        case 1:
                            if (!(i < len))
                                return [3 /*break*/, 4];
                            if (!(i in t))
                                return [3 /*break*/, 3];
                            val = t[i];
                            return [4 /*yield*/, predicate.call(thisArg, val, i, t)];
                        case 2:
                            // NOTE: Technically this should Object.defineProperty at
                            //       the next index, as push can be affected by
                            //       properties on Object.prototype and arrayPrototype.
                            //       But that method's new, and collisions should be
                            //       rare, so use the more-compatible alternative.
                            if (_a.sent()) {
                                res.push(val);
                            }
                            _a.label = 3;
                        case 3:
                            i++;
                            return [3 /*break*/, 1];
                        case 4: return [2 /*return*/, res];
                    }
                });
            });
        };
    }
    if (!arrayPrototype.findAsync) {
        arrayPrototype.findAsync = function findAsync(predicate, thisArg) {
            'use strict';
            return __awaiter(this, void 0, void 0, function () {
                var list, length, value, i;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this == null) {
                                throw new TypeError('Array.prototype.find called on null or undefined');
                            }
                            if (typeof predicate !== 'function') {
                                throw new TypeError('predicate must be a function');
                            }
                            list = Object(this);
                            length = list.length >>> 0;
                            i = 0;
                            _a.label = 1;
                        case 1:
                            if (!(i < length))
                                return [3 /*break*/, 4];
                            value = list[i];
                            return [4 /*yield*/, predicate.call(thisArg, value, i, list)];
                        case 2:
                            if (_a.sent()) {
                                return [2 /*return*/, value];
                            }
                            _a.label = 3;
                        case 3:
                            i++;
                            return [3 /*break*/, 1];
                        case 4: return [2 /*return*/, undefined];
                    }
                });
            });
        };
    }
    if (!arrayPrototype.findIndexAsync) {
        arrayPrototype.findIndexAsync = function findIndexAsync(predicate, thisArg) {
            'use strict';
            return __awaiter(this, void 0, void 0, function () {
                var list, length, value, i;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this == null) {
                                throw new TypeError('Array.prototype.findIndex called on null or undefined');
                            }
                            if (typeof predicate !== 'function') {
                                throw new TypeError('predicate must be a function');
                            }
                            list = Object(this);
                            length = list.length >>> 0;
                            i = 0;
                            _a.label = 1;
                        case 1:
                            if (!(i < length))
                                return [3 /*break*/, 4];
                            value = list[i];
                            return [4 /*yield*/, predicate.call(thisArg, value, i, list)];
                        case 2:
                            if (_a.sent()) {
                                return [2 /*return*/, i];
                            }
                            _a.label = 3;
                        case 3:
                            i++;
                            return [3 /*break*/, 1];
                        case 4: return [2 /*return*/, -1];
                    }
                });
            });
        };
    }
    if (!arrayPrototype.mapAsync) {
        arrayPrototype.mapAsync = function mapAsync(callback, thisArg) {
            return __awaiter(this, void 0, void 0, function () {
                var T, A, k, O, len, kValue, mappedValue;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this == null) {
                                throw new TypeError(' this is null or not defined');
                            }
                            O = Object(this);
                            len = O.length >>> 0;
                            // 4. If IsCallable(callback) is false, throw a TypeError exception.
                            // See: http://es5.github.com/#x9.11
                            if (typeof callback !== 'function') {
                                throw new TypeError(callback + ' is not a function');
                            }
                            // 5. If thisArg was supplied, let T be thisArg; else let T be undefined.
                            if (thisArg !== undefined) {
                                T = thisArg;
                            }
                            // 6. Let A be a new array created as if by the expression new Array(len)
                            //    where Array is the standard built-in constructor with that name and
                            //    len is the value of len.
                            A = new Array(len);
                            // 7. Let k be 0
                            k = 0;
                            _a.label = 1;
                        case 1:
                            if (!(k < len))
                                return [3 /*break*/, 4];
                            kValue = void 0, mappedValue = void 0;
                            if (!(k in O))
                                return [3 /*break*/, 3];
                            // i. Let kValue be the result of calling the Get internal
                            //    method of O with argument Pk.
                            kValue = O[k];
                            return [4 /*yield*/, callback.call(T, kValue, k, O)];
                        case 2:
                            // ii. Let mappedValue be the result of calling the Call internal
                            //     method of callback with T as the this value and argument
                            //     list containing kValue, k, and O.
                            mappedValue = _a.sent();
                            // iii. Call the DefineOwnProperty internal method of A with arguments
                            // Pk, Property Descriptor
                            // { Value: mappedValue,
                            //   Writable: true,
                            //   Enumerable: true,
                            //   Configurable: true },
                            // and false.
                            // In browsers that support Object.defineProperty, use the following:
                            // Object.defineProperty(A, k, {
                            //   value: mappedValue,
                            //   writable: true,
                            //   enumerable: true,
                            //   configurable: true
                            // });
                            // For best browser support, use the following:
                            A[k] = mappedValue;
                            _a.label = 3;
                        case 3:
                            // d. Increase k by 1.
                            k++;
                            return [3 /*break*/, 1];
                        case 4: 
                        // 9. return A
                        return [2 /*return*/, A];
                    }
                });
            });
        };
    }
})();
//# sourceMappingURL=/Users/btoth/Repositories/arraync/index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/arraync/index.js
// module id = 645
// module chunks = 0